export class UnitAddModel {
    public companyId: number;
    public facilityId: number;
    public name: string;
}
